import axios from 'axios'
import httpService from './httpService'

const apiService = {
    reProject () {
        return axios.post(httpService.apiPath + '/projections/reset')
    },
    getImage (id) {
        return axios.get(httpService.apiPath + '/images/auth/' + id, { responseType: 'arraybuffer' })
            .then(response => Buffer.from(response.data, 'binary').toString('base64'))
    },
    sendMail (recepients, subject, textbody, htmlbody) {
        return axios.post(httpService.apiPath + '/mails/tomembers',
            {
                recepientIds: recepients,
                subject: subject,
                bodyText: textbody,
                bodyHtml: htmlbody
            })
    },

    searchAll (term) {
        return axios.get(httpService.apiPath + '/search/' + term)
            .then(response => {
                return response
            })
    },
    suggestTeam (key) {
        return axios.get(httpService.apiPath + '/teams/suggestion/' + key)
            .then(response => {
                return response
            })
    },
    assignTeamToPlayer (playerId, teamId) {
        return axios.post(httpService.apiPath + '/players/' + playerId + '/teams/' + teamId, {})
            .then(response => {
                return response
            })
    },
    removeTeamFromPlayer (playerId, teamId) {
        return axios.delete(httpService.apiPath + '/players/' + playerId + '/teams/' + teamId, {})
            .then(response => {
                return response
            })
    },
    addEmail (playerId, email) {
        return axios.post(httpService.apiPath + '/players/' + playerId + '/contact/email', {
            email: email

        })
            .then(response => {
                return response
            })
    },
    removeEmail (playerId, email) {
        return axios.post(httpService.apiPath + '/players/' + playerId + '/contact/email/remove', {
            email: email
        })
            .then(response => {
                return response
            })
    },
    getPlayerProfile (playerId) {
        return axios.get(httpService.apiPath + '/players/' + playerId + '/profile')
            .then(response => {
                return response
            })
    },
    createTrainingSession (teamid, title, description, date, exercises, masteries) {
        return axios.post(httpService.apiPath + '/training/sessions',
            {
                title: title,
                date: date,
                teamid: teamid,
                description: description,
                exercises: exercises,
                warmupMasteries: masteries
            })
            .then(response => {
                return response
            })
    },

    setExerciseOrder (sessionId, exercises) {
        return axios.post(httpService.apiPath + '/training/sessions/' + sessionId + '/exercises/arrange',
            {
                OrderOfExercises: exercises

            })
    },

    setWarmupsOrder (sessionId, exercises) {
        return axios.post(httpService.apiPath + '/training/sessions/' + sessionId + '/warmups/arrange',
            {
                OrderOfExercises: exercises

            })
    },
    copySession (id, team, date) {
        return axios.post(httpService.apiPath + '/training/sessions/' + id + '/copy',
            {
                date: date,
                teamId: team
            })
            .then(response => {
                return response
            })
    },
    setPlayerCaution (id, playerId, caution) {
        return axios.post(httpService.apiPath + '/training/sessions/' + id + '/participation/caution',
            {
                playerid: playerId,
                caution: caution
            })
            .then(response => {
                return response
            })
    },
    setViewed (id) {
        if (id) {
            return axios.post(httpService.apiPath + '/training/sessions/' + id + '/viewed',
                {})
                .then(response => {
                    return response
                })
        } else {
            console.log('id must be set!')
        }
    },
    setParticipation (id, playerid, waslate, comment) {
        return axios.post(httpService.apiPath + '/training/sessions/' + id + '/participation',
            {
                playerid: playerid,
                comment: comment,
                waslate: waslate
            })
            .then(response => {
                return response
            })
    },
    rateExerciseOfSession (id, ex, rating) {
    // {id}/ex/{exercise}/rate
        return axios.post(httpService.apiPath + '/training/sessions/' + id + '/ex/' + ex + '/rate',
            {
                rating: rating
            })
            .then(response => {
                return response
            })
    },
    archiveTraining (id) {
        return axios.delete(httpService.apiPath + '/training/sessions/' + id)
            .then(response => {
                return response
            })
    },
    setDateForSession (sessionId, date) {
        return axios.post(httpService.apiPath + '/training/sessions/' + sessionId + '/date', { value: date }).then(response => {
            return response
        })
    },
    setDescriptionForSession (sessionId, description) {
        return axios.post(httpService.apiPath + '/training/sessions/' + sessionId + '/desc', { value: description }).then(response => {
            return response
        })
    },
    setTitleForSession (sessionId, title) {
        return axios.post(httpService.apiPath + '/training/sessions/' + sessionId + '/title', { value: title }).then(response => {
            return response
        })
    },

    addWarmupExerciseToSession (sessionId, shortKey) {
        return axios.post(httpService.apiPath + '/training/sessions/' + sessionId + '/wmp/' + shortKey, {}).then(response => {
            return response
        })
    },
    addExerciseToSession (sessionId, shortKey) {
        return axios.post(httpService.apiPath + '/training/sessions/' + sessionId + '/ex/' + shortKey, {}).then(response => {
            return response
        })
    },

    addMasteryToSession (sessionId, mastery) {
        return axios.post(httpService.apiPath + '/training/sessions/' + sessionId + '/bm/' + mastery, {}).then(response => {
            return response
        })
    },

    removeMasteryToSession (sessionId, mastery) {
        return axios.delete(httpService.apiPath + '/training/sessions/' + sessionId + '/bm/' + mastery, {}).then(response => {
            return response
        })
    },
    removeExerciseFromSession (sessionid, shortKey) {
        return axios.delete(httpService.apiPath + '/training/sessions/' + sessionid + '/remove/ex/' + shortKey)
            .then(response => {
                return response
            })
    },

    removeWarmupExerciseFromSession (sessionid, shortKey) {
        return axios.delete(httpService.apiPath + '/training/sessions/' + sessionid + '/remove/wmp/' + shortKey)
            .then(response => {
                return response
            })
    },
    removeParticipation (id, playerid, waslate, comment) {
        return axios.post(httpService.apiPath + '/training/sessions/' + id + '/participation/remove',
            {
                playerid: playerid,
                comment: comment
            })
            .then(response => {
                return response
            })
    },
    readPath (subPath) {
        return axios.get(httpService.apiPath + subPath)
            .then(response => {
                return response
            })
    },
    getAdminStatus () {
        return axios.get(httpService.apiPath + '/admin/status')
            .then(response => {
                return response
            })
    },
    getTeam (teamId) {
        return axios.get(httpService.apiPath + '/teams/' + teamId)
            .then(response => {
                return response
            })
    },
    setTeamYouth (teamId, youth) {
        return axios.post(httpService.apiPath + '/teams/' + teamId + '/youth/' + youth, {})
            .then(response => {
                return response
            })
    },
    addTeamMember (teamId, name, year) {
        return axios.post(httpService.apiPath + '/teams/' + teamId + '/members',
            {
                displayName: name,
                ageGroup: parseInt(year)
            })
            .then(response => {
                return response
            })
    },

    createInviteCode (teamId) {
        return axios.post(httpService.apiPath + '/teams/' + teamId + '/invite')
            .then(response => {
                return response
            })
    },
    addCoachToTeam (teamId, code) {
        return axios.post(httpService.apiPath + '/teams/' + teamId + '/invite/activate/' + code)
            .then(response => {
                return response
            })
    },
    getMyTeams () {
        return axios.get(httpService.apiPath + '/teams/me')
            .then(response => {
                return response
            })
    },
    getSessionForTeam (id) {
        return axios.get(httpService.apiPath + '/teams/' + id + '/sessions')
            .then(response => {
                return response
            })
    },
    getSsession (id) {
        return axios.get(httpService.apiPath + '/training/sessions/' + id)
            .then(response => {
                return response
            })
    },
    getMySessionsToday () {
        return axios.get(httpService.apiPath + '/training/sessions/me/today/participations')
            .then(response => {
                return response
            })
    },
    getMyNextSessions () {
        return axios.get(httpService.apiPath + '/training/sessions/me/next?c=3')
            .then(response => {
                return response
            })
    },
    getMyLastSessions () {
        return axios.get(httpService.apiPath + '/training/sessions/me/prev?c=3')
            .then(response => {
                return response
            })
    },
    createTeam (name, key, youth) {
        return axios.post(httpService.apiPath + '/teams', { key: key, name: name, youth: youth })
            .then(response => {
                return response
            })
    },
    createTeamEvent (teamId, eventName, time, location, foreignClub, description, kind, link) {
        return axios.post(httpService.apiPath + '/teams/' + teamId + '/events', {
            name: eventName,
            time: time,
            foreignClub: foreignClub,
            description: description,
            kind: kind,
            link: link
        })
            .then(response => {
                return response
            })
    },
    getPubEventByShareKey (shareKEY) {
        return axios.get(httpService.apiPath + '/events/pub/sk/' + shareKEY)
            .then(response => {
                return response
            })
    },
    getPubTeamEvents (teamid) {
        return axios.get(httpService.apiPath + '/pub/' + teamid)
            .then(response => {
                return response
            })
    },
    getMyUser () {
        return axios.get(httpService.apiPath + '/users/me')
            .then(response => {
                return response
            })
    },
    getTags () {
        return axios.get(httpService.apiPath + '/meta/tags')
            .then(response => {
                return response
            })
    },
    getForms () {
        return axios.get(httpService.apiPath + '/meta/forms')
            .then(response => {
                return response
            })
    },
    getYouths () {
        return axios.get(httpService.apiPath + '/meta/youth')
            .then(response => {
                return response
            })
    },
    getBallMasteries () {
        var url = httpService.apiPath + '/exercises/masteries'
        return axios.get(url)
            .then(response => {
                return response
            })
    },
    getExerciseByKey (key) {
        const url = httpService.apiPath + '/exercises/shortkey/' + key
        return axios.get(url)
            .then(response => {
                return response
            })
    },
    getMasteries () {
        const url = httpService.apiPath + '/BallMasteries'
        return axios.get(url)
            .then(response => {
                return response
            })
    },
    getMasteryById (id) {
        const url = httpService.apiPath + '/BallMasteries/id/' + id
        return axios.get(url)
            .then(response => {
                return response
            })
    },
    getExercises (youth, selectedForm, term, tags, page, pagesize) {
        var url = httpService.apiPath + '/exercises/youth/' + youth + '?page=' + page + '&pagesize=' + pagesize + '&term=' + term + '&'

        const params = []

        if (tags) {
            params.push('tags=' + tags)
        }

        if (selectedForm) {
            params.push('form=' + selectedForm)
        }

        var i
        for (i = 0; i < params.length; i++) {
            url += params[i] + '&'
        }

        return axios.get(url)
            .then(response => {
                return response
            })
    }
}

export default apiService